/**
 * domainControl 下各模块 SUBSCRIBE_SIGNALS / SEND_SIGNALS 的 displayName 与中文名称对照表
 * 用于 HU cps_tool 等页面展示
 */
export const DISPLAY_NAME_TO_LABEL: Record<string, string> = {
  // ----- IFTF -----
  UIRx_MotTq_FA: "前轴电机端驱动力",
  UIRx_MotTq_RA: "后轴电机端驱动力",
  UIRx_WhlBrkTqAct_FL_BCh1: "左前轮制动力矩",
  UIRx_WhlBrkTqAct_FR_BCh1: "右前轮制动力矩",
  UIRx_WhlBrkTqAct_RL_BCh1: "左后轮制动力矩",
  UIRx_WhlBrkTqAct_RR_BCh1: "右后轮制动力矩",
  UITx_SbTv_Ena: "SbTv 使能",
  UITx_SbTvRwsEna: "后轮转向使能",
  UITx_DisableBrk_FL: "左前制动禁用",
  UITx_DisableBrk_FR: "右前制动禁用",
  UITx_DisableBrk_RL: "左后制动禁用",
  UITx_DisableBrk_RR: "右后制动禁用",

  // ----- ADA -----
  UIRx_BrakeAirGap: "制动系统动态间隙",
  UIRx_BrkPdlPositionAct: "制动踏板开度",
  UIRx_DrvrReqTrgtFxBrk_Bch1: "驾驶员制动力请求",
  UIRx_FLWhlSpd_BCh1: "左前轮速",
  UIRx_FRWhlSpd_BCh1: "右前轮速",
  UIRx_RLWhlSpd_BCh1: "左后轮速",
  UIRx_RRWhlSpd_BCh1: "右后轮速",
  UIRx_TTL: "总轮速/TTL",
  UIRx_VehSpd: "车速",
  UITx_AdaDrvrCtrlSt: "ADA 驾驶员控制状态",

  // ----- ICC -----
  UIRx_ACUYawRate: "横摆角速度",
  UIRx_DeltaOff_FA: "前轴转角偏移",
  UIRx_DeltaOff_RA: "后轴转角偏移",
  UIRx_SBW_HWAAng: "方向盘转角",
  UIRx_FrontGearRto: "前轮转向比",
  UIRx_RearGearRto: "后轮转向比",
  UIRx_AxleStAng_FA: "前轴转向角",
  UIRx_AxleStAng_RA: "后轴转向角",
  UIRx_PinionTarVgr: "齿条目标速度",
  UIRx_PinionAct: "齿条实际位置",
  UITx_CoStab: "协调稳定",
  UITx_CoStaticChar: "协调静态特性",
  UITx_CoDynChar: "协调动态特性",
  UITx_ActuatorEna_SbW: "线控转向执行器使能",
  UITx_ActuatorEna_Rws: "后轮转向执行器使能",
  UITx_ActuatorEna_FAS: "前轴执行器使能",
  UITx_ActuatorEna_DTD: "DTD 执行器使能",
  UITx_FrontVgrSw: "前轮转向比开关",

  // ----- DMC -----
  UIRx_DMCTgtMod_FA: "前轴目标模式",
  UIRx_DMCTgtMod_RA: "后轴目标模式",
  UIRx_DMCWrkSt_FA: "前轴工作状态",
  UIRx_DMCWrkSt_RA: "后轴工作状态",
  UIRx_ACULongdAcc: "纵向加速度",
  UITx_DMC_Ena: "DMC 使能",

  // ----- CST -----
  UIRx_VehSdsl: "车辆静止",
  UIRx_PitchAng: "俯仰角",
  // UIRx_VehSpd: "车辆速度", // 与 ADA 中 UIRx_VehSpd 复用，避免重复定义
  UITx_CST_Ena: "CST 使能",

  // ----- DST -----
  UIRx_ABSSplitCtrlSts_BCh1: "ABS 分离控制状态",
  // UIRx_VehSpd: "车速", // 与 ADA 中 UIRx_VehSpd 复用，避免重复定义
  UIRx_mueFL: "左前轮附着系数",
  UIRx_mueFR: "右前轮附着系数",
  UIRx_mueRL: "左后轮附着系数",
  UIRx_mueRR: "右后轮附着系数",
  UITx_DST_Ena: "DST 使能",

  // ----- HDC -----
  UIRx_HDCAvlbl: "HDC 可用",
  UIRx_HDCDispVxTar: "HDC 显示目标车速",
  UIRx_HDCCtrlA: "HDC 控制加速度",
  UIRx_VAFBrkFxTrgt: "VAF 制动目标力",
  UITx_HDCCfg: "HDC 配置",

  // ----- MAABS -----
  // UITx_AdaDrvrCtrlSt: "ADA 驾驶员控制状态", // 与 ADA 中 UITx_AdaDrvrCtrlSt 复用，避免重复定义

  // ----- TAA -----
  UIRx_TAAAct: "TAA 激活状态",
  UITx_TAA_Ena: "TAA 使能",
  UITx_TAA_ModeSelect: "TAA 模式选择",

  // ----- IVSE (DUR) -----
  UIRx_ACULatAcc: "横向加速度",
  UIRx_VehMass: "车辆质量",
  UIRx_FLVertDynF: "左前垂向动载",
  UIRx_FRVertDynF: "右前垂向动载",
  UIRx_RLVertDynF: "左后垂向动载",
  UIRx_RRVertDynF: "右后垂向动载",
  UIRx_FxyFL: "左前轮纵向力",
  UIRx_FxyFR: "右前轮纵向力",
  UIRx_FxyRL: "左后轮纵向力",
  UIRx_FxyRR: "右后轮纵向力",
  UIRx_ThetaFxyFA: "前轴力角",
  UIRx_ThetaFxyRA: "后轴力角",
  UIRx_BetaObs: "观测质心侧偏角",
  UIRx_DUIdx_FL: "左前轮 DU 索引",
  UIRx_DUIdx_FR: "右前轮 DU 索引",
  UIRx_DUIdx_RL: "左后轮 DU 索引",
  UIRx_DUIdx_RR: "右后轮 DU 索引",
  UITx_DURrst: "DUR 复位",
  UITx_VLMReset: "VLM 复位",

  // ----- AccelDecelPitch 加减速俯仰 & X11 底盘能力展示相关 -----
  // 通用底盘姿态信号
  SusIMUPitchAngle: "悬架 IMU 俯仰角",
  SusIMUPitch: "悬架 IMU 俯仰角速度",
  SusIMURollAngle: "悬架 IMU 横滚角",
  SusIMURoll: "悬架 IMU 横滚角速度",
  SusBodySpdVert: "车身垂向/纵向速度",
  EPS_StrgAngSpeed: "转向角速度(占位信号)",
  EPS_StrgAng: "转向角",
  VehSpd: "车速",

  // --- X11 线控转向 + 后转（sbw） ---
  SBW_HWAAng: "方向盘转角 (SBW_HWAAng)",
  Rwa1RackPosn: "前转齿条位移",
  RrStRackPstnAct: "后转齿条位置",
  SRV_ModResdSig7: "后转控制预留信号7",
  ASUBodyRollAng: "悬架车身侧倾角 (ASU)",
  IRSFuncReq: "后转功能请求",
  IRSFuncSts: "后转功能状态",

  // --- X11 EMB ---
  SRV_ModResdSig1: "单轮失效开关",
  WhlClmpFAct_FL_C1: "前左轮实际夹紧力",
  WhlClmpFAct_FR_C1: "前右轮实际夹紧力",
  WhlClmpFAct_RL_C1: "后左轮实际夹紧力",
  WhlClmpFAct_RR_C1: "后右轮实际夹紧力",
  MSG_Icc_betaEst_rad: "整车质心侧偏角",
  MSG_Icc_AlphaRAObs_rad: "后轴侧偏角",
  ACULatAcc: "横向加速度",

  // --- X11 ASU 悬架相关 ---
  // 云台模式 / 弯道侧倾 / 加减速俯仰
  MSG_ASUBodyRollAng: "悬架计算侧倾角",
  MSG_ASUBodyPitchAng: "悬架计算俯仰角",
  // 四轮高度（短名称）
  SusHghtLvlSnsrFL: "前左高度",
  SusHghtLvlSnsrFR: "前右高度",
  SusHghtLvlSnsrRL: "后左高度",
  SusHghtLvlSnsrRR: "后右高度",
  // 四轮高度（MSG_ 前缀展示名）
  MSG_SusHghtLvlSnsrFL: "前左高度 (MSG)",
  MSG_SusHghtLvlSnsrFR: "前右高度 (MSG)",
  MSG_SusHghtLvlSnsrRL: "后左高度 (MSG)",
  MSG_SusHghtLvlSnsrRR: "后右高度 (MSG)",
  // 调平页
  MSG_SusIMUAccVert: "悬架 IMU 垂向加速度",
  MSG_SusIMURoll: "悬架 IMU 横滚角速度",
  MSG_SusIMUPitch: "悬架 IMU 俯仰角速度",
  PitchRate: "俯仰角速度",
  RollRate: "侧倾角速度",
  // 功能开关类
  SRV_AirSusAntiShakeModeSwReq: "云台防抖模式开关",
  SRV_AirSusRcvryMdSwReq: "沙地脱困模式请求",
  EmergLvlngReq: "紧急举升请求状态",
  SRV_EmergLvlngReq: "紧急举升请求",
  SRV_LaunchControlReq: "弹射起步请求",
  MSG_LaunchControlSts: "弹射起步功能状态",
};

/** 根据 displayName 取中文名称，无则返回 displayName */
export function getDisplayNameLabel(displayName: string): string {
  return DISPLAY_NAME_TO_LABEL[displayName] ?? displayName;
}
